export default {
    "name": "GetCars",
    "kind": "HoudiniQuery",
    "hash": "08cdb8e086d6742ba121c56d54127a300e903e43ca950ffdc6b3dc24aa90c3d6",

    "raw": `query GetCars {
  getCars {
    id
    name
    type
    energy
    isDefault
    consumptionLabels {
      distanceSystem
      value
    }
    maker
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getCars": {
                "type": "Car",
                "keyRaw": "getCars",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "String",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "type": {
                            "type": "CarType",
                            "keyRaw": "type",
                            "nullable": true,
                            "visible": true
                        },

                        "energy": {
                            "type": "CarEnergy",
                            "keyRaw": "energy",
                            "visible": true
                        },

                        "isDefault": {
                            "type": "Boolean",
                            "keyRaw": "isDefault",
                            "visible": true
                        },

                        "consumptionLabels": {
                            "type": "ConsumptionLabel",
                            "keyRaw": "consumptionLabels",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "distanceSystem": {
                                        "type": "DistanceSystem",
                                        "keyRaw": "distanceSystem",
                                        "visible": true
                                    },

                                    "value": {
                                        "type": "String",
                                        "keyRaw": "value",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "maker": {
                            "type": "String",
                            "keyRaw": "maker",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=b6c5e47d5dd55358aaa7b20012fc359b29eca30efb9c3ae1d1dff3593202f7db";